import RateSheet from './RateSheet.js'
import store from '@/store'
export default class BaseCost {
  constructor (serverBaseCost) {
    this.costCalculationId = serverBaseCost?.costCalculationId
    this.rate = serverBaseCost?.rate
    this.payBy = serverBaseCost?.payBy
    this.payOn = serverBaseCost?.payOn
    this.rateSheetId = serverBaseCost?.rateSheetId
    if (serverBaseCost != null) this.rateSheet = BaseCost.createStandardizedRateSheet(serverBaseCost?.rateSheet, this.rateSheetId)
  }

  static createStandardizedRateSheet (rateSheet, rateSheetId) {
    if (!rateSheet) {
      return null
    }

    if (rateSheet.effectiveDate !== undefined || rateSheet.expirationDate !== undefined || rateSheet.rateSheetLines !== undefined) {
      return RateSheet.fromServerResponse(rateSheet)
    }

    return RateSheet.fromDefinition({ name: rateSheet, rateSheetId: rateSheetId })
  }

  static async fromNamedRate (namedRate) {
    const baseCost = new BaseCost(namedRate.costCalculation)
    if (baseCost.rateSheetId == null) return baseCost
    const rateSheet = await store.dispatch('rate-sheet/fetchRateSheet', baseCost.rateSheetId)
    baseCost.rateSheet = RateSheet.fromServerResponse(rateSheet)
    return baseCost
  }
}
